import { StoreDefinition } from 'pinia';
import { getCurrentInstance, onBeforeUnmount } from 'vue';

let componentCounter = 0;

export function useStore<T extends StoreDefinition>(storeDefinition: T): ReturnType<T> {
  const component = getCurrentInstance();
  const storeInstance = storeDefinition() as ReturnType<T>;

  if (!component || !storeInstance.subscribers) {
    return storeInstance;
  }

  const key = getUniqueComponentKey();

  const storeWithSubscribers = storeInstance as ReturnType<T> & { subscribers: string[] };
  storeWithSubscribers.subscribers.push(key);

  onBeforeUnmount(() => {
    storeWithSubscribers.subscribers = storeWithSubscribers.subscribers.filter((subscriber: string) => subscriber !== key);

    if (storeWithSubscribers.subscribers.length === 0) {
      console.debug(`Disposing store ${storeDefinition.$id}`);
      storeWithSubscribers.dispose();
    }
  });

  return storeWithSubscribers;
}

function getUniqueComponentKey(): string {
  const instance = getCurrentInstance();
  const componentName = instance?.proxy?.$options.name || 'UnnamedComponent';
  const componentId = componentCounter++;
  return `${componentName}-${componentId}`;
}
